import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode($setup["Grid"], {
                "current-page": $setup.currentPage,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event) => (($setup.currentPage) = $event)),
                "paginated-results": "",
                "data-cy": "hospital-list",
                access: $props.access,
                columns: $setup.gridColumns,
                data: $setup.gridData,
                "is-loading": $setup.allHospitalsLoading,
                "page-info": $setup.cursors[$setup.currentPage - 1],
                "page-size": $setup.pageSize,
                "total-pages": $setup.cursors.length,
                onDelete: _cache[1] || (_cache[1] = ($event) => ($setup.emit('delete', $event))),
                onEdit: _cache[2] || (_cache[2] = ($event) => ($setup.emit('edit', $event))),
                onView: _cache[3] || (_cache[3] = ($event) => ($setup.emit('view', $event)))
            }, null, 8, ["current-page", "access", "columns", "data", "is-loading", "page-info", "page-size", "total-pages"])
        ])
    ]));
}
